import React, { FC, useCallback } from 'react'

import { createPortal } from 'react-dom'

import useToggle from 'Hooks/useToggle'

import ForgotPasswordModal from '../ForgotPasswordModal'
import PasswordField from '../PasswordField'

const Password: FC = () => {
  const [forgotPasswordModalVisibility, , openForgotPasswordModal, closeForgotPasswordModal] = useToggle()

  const handleForgotPasswordClick = useCallback(() => {
    openForgotPasswordModal()
  }, [openForgotPasswordModal])

  return (
    <div>
      <PasswordField
        required
        autoComplete="current-password"
        label="Password"
        wrapperClassName="checkout-contact-flow__field-group form-group mb-0"
      />

      <button className="checkout-button mt-2" type="button" onClick={handleForgotPasswordClick}>
        Forgot your password?
      </button>
      <div>
        {forgotPasswordModalVisibility
          ? createPortal(<ForgotPasswordModal closeModal={closeForgotPasswordModal} />, document.body)
          : null}
      </div>
    </div>
  )
}

export default Password
